var React = require('react');

function IconFilter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M8.505 7h15.082l-7.556 9.45zm-4.147-.585C7.4 10.3 13.03 17.5 13.03 17.5v9a1.509 1.509 0 0 0 1.508 1.5h3.016a1.509 1.509 0 0 0 1.508-1.5v-9s5.61-7.2 8.657-11.085A1.5 1.5 0 0 0 26.528 4H5.549a1.5 1.5 0 0 0-1.191 2.415z","transform":"translate(-4.038 -4)"}));
}

IconFilter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconFilter;

IconFilter.default = IconFilter;
